import Box from "@mui/material/Box";

import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { ArrowBackRounded } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { audienceDrawerElements } from "./data";
import FacebookAudiencePush from "./DashboardComponents/FacebookAudiencePush/FacebookAudiencePush";
import MoengageAudienceDataPush from "./DashboardComponents/MoengageAudienceDataPush/MoengageAudienceDataPush";

const AudienceDashboard = () => {
	const [pathName, service] = useOutletContext();
	const navigate = useNavigate();

	const tabComponents = {
		[audienceDrawerElements.audience.types.facebook.key]: {
			...audienceDrawerElements.audience.types.facebook,
			component: <FacebookAudiencePush activeService={service} />,
		},
		// [audienceDrawerElements.audience.types.google.key]: {
		// 	...audienceDrawerElements.audience.types.google,
		// 	component: <GoogleAudienceDataPush activeService={service} />,
		// },
		[audienceDrawerElements.audience.types.moengage.key]: {
			...audienceDrawerElements.audience.types.moengage,
			component: <MoengageAudienceDataPush activeService={service} />,
		},
	};

	return (
		<Box width="100%">
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Typography variant="h5">{service?.name}</Typography>
			</Box>
			<Box width="95%" margin="auto">
				{tabComponents?.[pathName]?.component}
			</Box>
		</Box>
	);
};

export default AudienceDashboard;
